import React, { memo } from "react"
import doneIcon from "@images/ic-done.svg"
import { useBurgerConfiguration } from "../../../../hooks"
import { NavButtons } from "..";
import {
  CLOSE_BURGER_MENU_TEXT,
  OPEN_BURGER_MENU_TEXT,
} from "../../../../constants"
import {
    StyledBurgerMenuContainer,
    StyledIcon,
    StyledIconContainer,
    StyledIconText,
    StyledLinksContainerStyles,
} from "./styled"

const BurgerMenu = ({
  showLinks,
  handleClick,
  openMobileFilters,
  setOpenMobileFilters,
  path,
  setShowLinks,
}) => {
    
  const {
    isClosing,
    menuIcon,
    isTablet,
    generateLinksContainer,
    handleMenuToggle,
    handleFilterToggle,
  } = useBurgerConfiguration({ showLinks, setShowLinks, path, handleClick, setOpenMobileFilters })

  return (
    <>
      <StyledBurgerMenuContainer>
        {!openMobileFilters ? (
          <StyledIconContainer onClick={handleMenuToggle}>
            <StyledIcon src={menuIcon} />
            <StyledIconText>
              {showLinks && !isClosing
                ? CLOSE_BURGER_MENU_TEXT
                : OPEN_BURGER_MENU_TEXT}
            </StyledIconText>
          </StyledIconContainer>
        ) : (
          <StyledIconContainer onClick={handleFilterToggle}>
            <StyledIcon src={doneIcon} />
          </StyledIconContainer>
        )}
      </StyledBurgerMenuContainer>

      {showLinks && (
        <>
         {isTablet && <NavButtons isClosing={isClosing} />}
          <StyledLinksContainerStyles isClosing={isClosing}>
            {generateLinksContainer}
          </StyledLinksContainerStyles>
        </>
      )}
    </>
  )
}

export default memo(BurgerMenu)
